export enum BeachView {
  MY_TOURNAMENTS = 1,
  FOLDERS = 2,
  TOURNAMENTS = 3,
  TOURNAMENTS_ADD = 4,
  TOURNAMENT_DETAIL = 6,
  TOURNAMENT_ATTACHMENTS = 7,
  TOURNAMENT_APPLICATIONS = 8,
  TOURNAMENT_QUALIFICATIONS = 9,
  TOURNAMENT_MAIN_COMPETITION = 10,
  TOURNAMENT_RESULTS = 11,
  TOURNAMENT_ENTRY = 12,
  RANKINGS = 13,
  RANKINGS_DETAIL = 14,
  RANKINGS_SETTINGS = 15,
  RANKINGS_EDIT = 16,
  TEMPLATES = 17,
  STATISTIC = 18,
  PLAYER = 19,
  APPLICATION_EDIT = 20,
  FOLDER_EDIT = 21,
  MATCH_EDIT = 22,
  TOURNAMENT_DELETE = 23,
  RECALCULATE_RANKINGS = 24,
}
export enum BeachRefereeView {
  MY_DELEGATION = 1,
  TOURNAMENTS = 2,
  TOURNAMENT_DETAIL = 3,
  LISTS = 4,
  LIST_DETAIL = 5,
  LIST_USER = 6,
  STATISTIC = 7,
  ADMIN_EDIT = 8,
  PAYMENTS = 9,
  PAYMENTS_ADMIN = 10,
}
export enum BeachDelegationView {
  CATEGORIES = 1,
  CATEGORY_DETAIL = 2,
  REFEREES = 3,
  REFEREE_DETAIL = 4,
}
export enum BeachStatisticsView {
  OVERVIEW = 1,
  CLUBS = 2,
  PERSONS = 3,
}
